import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F4.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame4() {
    let [isLoading, setIsLoading] = useState(false)
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, [])

    if (isLoading === true) {
        return (<div className="F3_image"></div>)
    } else {
        return (
            <div className="F4_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F4_entryBox">
                    <div className="F4_paragraph">
                        {language === 'english' ?
                            <p className="F4_paragraphEnglish">Saira has locked herself in room, will you help her come out<span style={{paddingLeft: '0.25vw'}}>!</span></p>
                            :
                            <p className="F4_paragraphUrdu">سائرا نے خود کو اپنے کمرے میں بند کر لیا ہے، اس کو کمرے سے باہر آنے کا حوصلہ دیں۔</p>
                        }

                    </div>
                    <div className="F4_timeline">
                        <div className='F4_timelineBar'>
                            <div className='F4_timelineFill'></div>
                            <span className='F4_timelineText'>4/16</span>
                        </div>
                    </div>

                    <div className="F4_nextFrames">
                        <div className="F4_nextFrame1"></div>
                        <div className="F4_nextFrame2"></div>
                        <div className="F4_nextFrame3"></div>
                    </div>

                    <div className='F4_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep1_lastVisitFrame(4)) }} className='F4_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame4;